import BaseView from './utilities/baseView.js';

class CitiesInRegionView extends BaseView {
    openModalButtons = document.querySelectorAll('.city > span');
    modal = document.querySelector('.city-modal-container');

    constructor() {
        super(citiesInRegionConfig);
        this.bindButtons();
        this.setStyleToHiddenContent();
    }

    bindButtons = () => {
        this.openModalButtons.forEach(button => {
            button.addEventListener('click', () => {
                const container = button.parentElement;
                const title = container.querySelector('h3').innerText;
                const description = container.querySelector('div').innerHTML;
                const link = container.querySelector('a').href;
                const modalTitle = this.modal.querySelector('h2 a');
                const modalDescription = this.modal.querySelector('div');

                modalTitle.innerText = title;
                modalTitle.href = link;
                modalDescription.innerHTML = description;

                this.modal.parentElement.scroll({
                    top: 0
                });
            });
        });
    }

    setStyleToHiddenContent = () => {
        const containers = document.querySelectorAll('.city > div');

        containers.forEach(item => {
            item.style["-webkit-box-orient"] = "vertical";
        });
    }
}

new CitiesInRegionView();